// @flow
import { getUrlString } from "common/services/formatters/PlaceFormatter"
import { isNoReturn } from "../../records/SearchDate/utils"
import type SearchFormState from "../../records/SearchFormState"
import type Options from "../../records/Options"
import type Formatter from "../formatters/Formatter"

const searchFormToUrl = (
  formData: SearchFormState,
  defaultSearchForm: SearchFormState,
  urlFormatter: Formatter,
  getPath: (key: string) => string,
  options: Options,
) => {
  const originString = getUrlString(formData.get("origin"))
  const destinationString = getUrlString(formData.get("destination"))
  const outboundDateString = urlFormatter.makeSearchDateUrl(formData.get("outboundDate"))
  const inboundDateString = urlFormatter.makeSearchDateUrl(formData.get("inboundDate"))

  const prefix = `/${options.language}`
  const searchPath = options.wowairRequestDate ? getPath("customSearch") : getPath("search")

  if (formData.getMode() === "multicity") {
    return `${prefix}/${searchPath}`
  }

  let lastFilled = false

  const fields = {}

  if (
    !formData.inboundDate.isDefault ||
    (!isNoReturn(formData.get("inboundDate")) &&
      inboundDateString !== urlFormatter.makeSearchDateUrl(defaultSearchForm.get("inboundDate")))
  ) {
    fields.inboundDate = `/${inboundDateString}`
    lastFilled = true
  } else {
    fields.inboundDate = ""
  }

  // If lastFilled, then inboundDate is set. Need to set outbound also
  if (
    lastFilled ||
    !formData.outboundDate.isDefault ||
    outboundDateString !== urlFormatter.makeSearchDateUrl(defaultSearchForm.get("outboundDate"))
  ) {
    fields.outboundDate = `/${outboundDateString}`
    lastFilled = true
  } else {
    fields.outboundDate = ""
  }

  let destinationFilled = false

  if (
    destinationString !== getUrlString(defaultSearchForm.get("destination")) ||
    !formData.destination.isDefault()
  ) {
    fields.destination = `/${destinationString}`
    lastFilled = true
    destinationFilled = true
  } else {
    fields.destination = lastFilled ? "/--" : ""
  }

  // If destinationFilled, then destination is set, need to set origin also - for logging pax search
  if (
    destinationFilled ||
    originString !== getUrlString(defaultSearchForm.get("origin")) ||
    !formData.origin.isDefault()
  ) {
    fields.origin = `/${originString}`
    lastFilled = true
  } else {
    fields.origin = lastFilled ? "/--" : ""
  }

  return `${prefix}/${searchPath}${fields.origin}${fields.destination}${fields.outboundDate}${fields.inboundDate}`
}

export default searchFormToUrl
